export const formatCompactNumber = (value) => {
    return new Intl.NumberFormat("pt-BR", {
        notation: Math.abs(value) >= 10000 ? "compact" : "standard",
        maximumFractionDigits: 1
    }).format(value)
}

export const inferChartUnit = (data = {}) => {
    if (data.unit) return data.unit

    const text = `${data.title || ""} ${data.id || ""}`.toLowerCase()

    if (text.includes("mensagem") || text.includes("messages")) return "mensagens"
    if (text.includes("conversa") || text.includes("conversation")) return "conversas"
    if (text.includes("lead")) return "leads"
    if (text.includes("clique") || text.includes("click")) return "cliques"
    if (text.includes("impress")) return "impressões"

    return ""
}

export const formatValueWithUnit = (value, unit = "") => {
    if (value === undefined || value === null || value === "") return "-"

    const formattedValue = typeof value === "number" ? formatCompactNumber(value) : value
    return unit ? `${formattedValue} ${unit}` : formattedValue
}
